export const chartColors = ['#3AC08F', '#00A7F8', '#5FC6D0', '#A2D2E8', '#C4E4CF', '#7DBB9A', '#96D1E1'];

export const getChartColorByIndex = (index: number) => {
  // repeat colors if index > colors length
  if (index > chartColors.length - 1) return chartColors[index % chartColors.length];
  return chartColors[index];
};
